import {initialize as initVueApp} from '../modules/resources-app';
import Accordion from '../modules/accordions';
import {waitForElement} from '../util';

export default {
  finalize() {
    initVueApp();
    waitForElement('.faq-accordion-row')
        .then(() => {
          new Accordion({
            accordionItemSelector: '.faq-accordion-row',
            accordionBodySelector: '.faq-accordion-content',
            accordionTitleSelector: '.faq-accordion-title',
            collapseAllSelector: '.js-faq-accordion-button-collapse',
            openAllSelector: '.js-faq-accordion-button-open',
          });
        })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/resources.js